import React, { useState } from "react";
import "./VideoSection.css";
import untitle from "../../img/Untitled-1.png"
import { IoCloseOutline } from "react-icons/io5";


const VideoSection = () => {
  const [modal, setModal] = useState(false);
  const openModal = () => {
    if (!modal) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    setModal(!modal);
  };

  return (
    <section className="vedio">
      <div className="container-1240">
        <div className="row">
          <div className="col-lg-12">
            <div className="vedio-img">
              <div className="vedio-content">
                <h2 className="text-white text-center">
                  Take a Virtual Tour of Our Clinic
                </h2>
              </div>
           
              <div className="video-popu">
              <button onClick={openModal}>
                <img src={untitle} alt="videoIcon" />
                {modal ? (
                  <section className="modal__bg">
                    <div className="modal__align">
                      <div className="modal__content" modal={modal}>
                        <IoCloseOutline
                          className="modal__close"
                          arial-label="Close modal"
                          onClick={setModal}
                        />
                        <div className="modal__video-align">
                          <iframe
                            width="800"
                            height="500"
                            src="https://www.youtube.com/embed/DUfXdcpEfMs"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : null}
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
